"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlignType = void 0;
var classnames_1 = __importDefault(require("classnames"));
var memoize_1 = __importDefault(require("lodash/memoize"));
var omit_1 = __importDefault(require("lodash/omit"));
var throttle_1 = __importDefault(require("lodash/throttle"));
var react_1 = __importDefault(require("react"));
var stickyfilljs_1 = require("stickyfilljs");
var Badge_1 = __importDefault(require("../Badge"));
var Icon_1 = __importStar(require("../Icon"));
var CheckBox_1 = __importDefault(require("../Input/CheckBox"));
var Colors_1 = require("../Colors");
var FilterItem_1 = __importDefault(require("../FilterBar/FilterItem"));
var LocaleProvider_1 = __importDefault(require("../LocaleProvider"));
var ProgressIndicator_1 = __importDefault(require("../ProgressIndicator"));
var ContentRow_1 = __importDefault(require("./ContentRow"));
var ParentRow_1 = __importDefault(require("./ParentRow"));
var AlignType;
(function (AlignType) {
    AlignType["Left"] = "left";
    AlignType["Right"] = "right";
    AlignType["Center"] = "center";
})(AlignType = exports.AlignType || (exports.AlignType = {}));
var DataBody = /** @class */ (function (_super) {
    __extends(DataBody, _super);
    function DataBody(props) {
        var _this = _super.call(this, props) || this;
        _this.filterSelectableRows = memoize_1.default(function (list) {
            var rowSelectable = _this.props.rowSelectable;
            /* eslint-disable-next-line @typescript-eslint/no-unsafe-return */
            return rowSelectable ? list.filter(function (item) { return rowSelectable(item); }) : list;
        });
        _this.tableRef = react_1.default.createRef();
        _this.stickyFillApplied = false;
        _this.changeLocale = function () {
            _this.forceUpdate();
        };
        _this.resetColumnSizes = function () {
            if (_this.tableRef.current && _this.props.fixedHeader) {
                _this.setState({
                    needReset: true,
                });
            }
        };
        // Get header widths from rows in the tbody
        _this.getHeaderWidths = function (prevState) {
            if (prevState === void 0) { prevState = null; }
            return __awaiter(_this, void 0, void 0, function () {
                var columnWidths;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(this.tableRef.current && this.props.fixedHeader === true && this.props.data && this.props.data.length)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.findWidthsForRow(prevState)];
                        case 1:
                            columnWidths = _a.sent();
                            if (!prevState) {
                                this.setState({
                                    needReset: true,
                                });
                            }
                            else if (prevState && String(prevState.columnWidths) === String(columnWidths) && this.state.needReset) {
                                this.setState({
                                    columnWidths: columnWidths,
                                    needReset: false,
                                });
                            }
                            else if (prevState && String(prevState.columnWidths) !== String(columnWidths) && this.state.needReset) {
                                this.setState({
                                    columnWidths: columnWidths,
                                });
                            }
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        };
        _this.handleSelectAllRows = function (e) {
            var selectedRows = e.target.classList.contains("unchecked") ? _this.filterSelectableRows(_this.props.data) || [] : [];
            _this.propagateSelectionChange(selectedRows);
        };
        _this.handleSelectRow = function (item) {
            return function () {
                var selectedRows = _this.props.selectedRows || [];
                var newSelectedRows = selectedRows.indexOf(item) >= 0 ? selectedRows.filter(function (i) { return i !== item; }) : __spreadArrays(selectedRows, [item]);
                _this.propagateSelectionChange(newSelectedRows);
            };
        };
        _this.filterChange = function (id, values, operator) {
            var _a;
            var _b, _c;
            var filters;
            if (values) {
                filters = __assign(__assign({}, (((_b = _this.props.filterBarProps) === null || _b === void 0 ? void 0 : _b.selected) || {})), (_a = {}, _a[id] = {
                    values: values,
                    operator: operator,
                }, _a));
            }
            else {
                filters = omit_1.default((_c = _this.props.filterBarProps) === null || _c === void 0 ? void 0 : _c.selected, id);
            }
            if (_this.props.filterBarProps && _this.props.filterBarProps.onFilterChange) {
                _this.props.filterBarProps.onFilterChange(filters, _this.props.filterBarProps.visible || [], false);
            }
        };
        _this.findWidthsForRow = function (prevState) {
            if (prevState === void 0) { prevState = null; }
            return new Promise(function (resolve, reject) {
                requestAnimationFrame(function () {
                    var width = [];
                    if (!_this.tableRef.current) {
                        return resolve([]);
                    }
                    for (var _i = 0, _a = _this.tableRef.current.children[0].children[0].children; _i < _a.length; _i++) {
                        var el = _a[_i];
                        width.push(el.getBoundingClientRect().width);
                    }
                    width.push(_this.tableRef.current.getBoundingClientRect().width);
                    resolve(width);
                });
            });
        };
        LocaleProvider_1.default.on(_this.changeLocale);
        _this.throttledUpdate = throttle_1.default(_this.resetColumnSizes, 500);
        _this.state = {
            needReset: true,
        };
        return _this;
    }
    DataBody.getDerivedStateFromProps = function (nextProps, prevState) {
        if (String(nextProps.selectedColumns) !== String(prevState.selectedColumns)) {
            return {
                needReset: true,
                columnWidths: undefined,
                selectedColumns: nextProps.selectedColumns,
            };
        }
        if (nextProps.data && nextProps.data !== prevState.dataPointer) {
            return {
                needReset: true,
                columnWidths: undefined,
                dataPointer: nextProps.data,
            };
        }
        return null;
    };
    DataBody.prototype.componentWillUnmount = function () {
        LocaleProvider_1.default.off(this.changeLocale);
        window.removeEventListener("resize", this.throttledUpdate);
    };
    DataBody.prototype.componentDidMount = function () {
        var _this = this;
        /* eslint-disable-next-line @typescript-eslint/no-misused-promises */
        requestAnimationFrame(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getHeaderWidths()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        window.addEventListener("resize", this.throttledUpdate);
    };
    DataBody.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _this = this;
        /* eslint-disable-next-line @typescript-eslint/no-misused-promises */
        requestAnimationFrame(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getHeaderWidths(prevState)];
                    case 1:
                        _a.sent();
                        if (this.stickyFillApplied === false &&
                            this.props.data &&
                            this.props.data.length > 0 &&
                            this.props.fixedHeader &&
                            !this.state.needReset) {
                            stickyfilljs_1.add(document.querySelectorAll(".sticky"));
                            this.stickyFillApplied = true;
                        }
                        else if ((this.props.data && this.props.data.length === 0) || this.state.needReset) {
                            this.stickyFillApplied = false;
                        }
                        return [2 /*return*/];
                }
            });
        }); });
    };
    DataBody.prototype.propagateSelectionChange = function (selectedRows) {
        var onRowSelection = this.props.onRowSelection;
        if (onRowSelection) {
            onRowSelection(selectedRows);
        }
    };
    /* eslint-disable-next-line sonarjs/cognitive-complexity */
    DataBody.prototype.render = function () {
        var _this = this;
        var _a = this.props, columns = _a.columns, data = _a.data, value = _a.value, sortBy = _a.sortBy, defaultSortBy = _a.defaultSortBy, onSortChange = _a.onSortChange, onClick = _a.onClick, fixedHeader = _a.fixedHeader, selectableRows = _a.selectableRows, filterBarProps = _a.filterBarProps, childrenProperty = _a.childrenProperty, subContentProperty = _a.subContentProperty, subContent = _a.subContent, loading = _a.loading;
        var _b = this.state, needReset = _b.needReset, columnWidths = _b.columnWidths;
        var selectedRows = this.props.selectedRows || [];
        var filteredSelectableData = this.filterSelectableRows(data);
        // When selected columns are empty, use all available columns
        var selectedIds = this.props.selectedColumns || [];
        var sortColumn = sortBy ? sortBy.key : "";
        var defaultSortColumn = defaultSortBy ? defaultSortBy.key : "";
        // Previously this was an array, but we need class names etc..
        var selectedColumns = [];
        var header = [];
        if (selectableRows) {
            var allSelected = filteredSelectableData && filteredSelectableData.length && selectedRows.length === filteredSelectableData.length;
            header.push(react_1.default.createElement("th", { key: -1, className: "__checkbox", style: { width: 54, minWidth: 54, maxWidth: 54 } },
                react_1.default.createElement(CheckBox_1.default, { className: classnames_1.default("big", !allSelected && selectedRows.length && "partial"), onChange: this.handleSelectAllRows, value: allSelected })));
        }
        // Sort and filter unused columns
        columns
            .filter(function (item) { return item.alwaysShow || selectedIds.indexOf(item.id) >= 0; })
            .sort(function (a, b) { return selectedIds.indexOf(a.id) - selectedIds.indexOf(b.id); })
            .forEach(function (item, cIndex) {
            var sortIcon;
            var sort = !item.nosort;
            var currentSort = sortColumn === item.id;
            var sortHandler;
            selectedColumns.push(item);
            if (sort) {
                var icon = Icon_1.IconType.SortArrowBoth;
                if (sortBy && currentSort) {
                    if (sortBy.sort === "asc") {
                        icon = Icon_1.IconType.SortArrowUp;
                    }
                    else {
                        icon = Icon_1.IconType.SortArrowDown;
                    }
                }
                sortIcon = react_1.default.createElement(Icon_1.default, { icon: icon, width: 9, height: 14, className: "sort_indicator" });
                // try to find parent by given className, return null if not found
                var parentByClassName_1 = function (el, className) {
                    while (el.className !== className) {
                        el = el.parentNode;
                        if (!el) {
                            return null;
                        }
                    }
                    return el; /* eslint-disable-line @typescript-eslint/no-unsafe-return */
                };
                sortHandler = function (e) {
                    // prevent sort action if comes from filter component
                    if (parentByClassName_1(e.nativeEvent.target, "respectkit__filter_bar__item") !== null) {
                        return;
                    }
                    if (onSortChange) {
                        // set default sorting on the third click
                        // tslint:disable-next-line: max-line-length
                        var columnKey = defaultSortColumn && currentSort && sortBy && sortBy.sort === "desc" ? defaultSortColumn : item.id;
                        onSortChange({
                            key: columnKey,
                            sort: currentSort ? (sortBy && sortBy.sort === "asc" ? "desc" : "asc") : "asc",
                        });
                    }
                };
            }
            var filterItemData;
            var filterItemElement;
            if (filterBarProps && filterBarProps.filters && filterBarProps.filters.length > 0) {
                filterBarProps.filters.forEach(function (itemData) {
                    if (itemData.id === item.id) {
                        filterItemData = __assign({}, itemData);
                        var selected = void 0;
                        /* eslint-disable-next-line no-prototype-builtins */
                        if (filterBarProps.selected && filterBarProps.selected.hasOwnProperty(filterItemData.id)) {
                            selected = filterBarProps.selected[filterItemData.id].values;
                        }
                        filterItemElement = (react_1.default.createElement(FilterItem_1.default, __assign({ localization: filterBarProps.localization, onChange: _this.filterChange, selected: selected, key: filterItemData.id + "_filter", inTableHeader: true }, filterItemData)));
                    }
                });
            }
            var style;
            if (needReset && !columnWidths && item.width) {
                style = {
                    width: item.width,
                    minWidth: item.width,
                };
            }
            else if (needReset && columnWidths && item.width) {
                var width = columnWidths[cIndex + (selectableRows ? 1 : 0)];
                style = {
                    width: item.width > width ? item.width : width,
                    minWidth: item.width > width ? item.width : width,
                };
            }
            else if (!needReset && columnWidths) {
                // Column with checkbox or without
                var width = columnWidths[cIndex + (selectableRows ? 1 : 0)];
                style = {
                    width: width,
                    minWidth: width,
                };
            }
            header.push(react_1.default.createElement("th", { key: item.id, className: classnames_1.default({ sortable: sort, sorted: currentSort }, item.className), style: style, onClick: sortHandler },
                react_1.default.createElement("div", { className: "body_header" },
                    react_1.default.createElement("div", { className: classnames_1.default("sort_label", { sort_link: filterItemElement }, item.align || "") },
                        sortIcon,
                        item.hideLabel === true ? "" : item.label,
                        filterItemElement))));
        });
        var index = 0;
        var body = null;
        if (data && data.length > 0) {
            var renderRows_1 = function (rows, isChild) {
                if (isChild === void 0) { isChild = false; }
                return rows.map(function (item) {
                    var hasChildRows = childrenProperty && item[childrenProperty] && item[childrenProperty].length > 0;
                    var hasSubContent = subContentProperty && item[subContentProperty];
                    var line = selectedColumns.map(function (column, colIndex) {
                        var arrow = null;
                        if (colIndex === 0 && isChild) {
                            arrow = react_1.default.createElement(Icon_1.default, { icon: Icon_1.IconType.ArrowTopRight, className: "child_icon" });
                        }
                        var defaultSelector = column.id;
                        var columnData;
                        if (isChild && column.childrenSelector) {
                            columnData = value(item, column.childrenSelector);
                        }
                        else if (hasChildRows && item[defaultSelector] === undefined && column.childrenSelector) {
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            columnData = value(item[childrenProperty][0], column.childrenSelector);
                        }
                        else if (column.id === "attachment") {
                            columnData = value(item, defaultSelector) ? react_1.default.createElement(Icon_1.default, { icon: Icon_1.IconType.Attachment, width: 24, height: 24 }) : null;
                        }
                        else if (column.id === "opened") {
                            // tslint:disable-next-line: max-line-length
                            columnData = value(item, defaultSelector) ? (react_1.default.createElement(Badge_1.default, { color: Colors_1.BaseColor.Green }, LocaleProvider_1.default.locs.datatable.openstate.opened)) : (react_1.default.createElement(Badge_1.default, { color: Colors_1.BaseColor.Orange }, LocaleProvider_1.default.locs.datatable.openstate.closed));
                        }
                        else {
                            columnData = value(item, defaultSelector);
                        }
                        var clickable = !(column.className && column.className.indexOf("noclick") !== -1);
                        var columnStyle;
                        if (columnWidths && !needReset) {
                            // Column with checkbox or without
                            var width = columnWidths[colIndex + (selectableRows ? 1 : 0)];
                            columnStyle = {
                                minWidth: width,
                                width: width,
                                maxWidth: width,
                            };
                        }
                        return (react_1.default.createElement("td", { onClick: clickable && onClick ? function () { return onClick(item); } : undefined, key: "table_row_" + index++, className: classnames_1.default({
                                sorted: sortColumn === column.id,
                                breakWords: column.breakWords,
                            }, column.className, column.id, column.align || ""), style: columnStyle },
                            arrow,
                            columnData));
                    });
                    if (selectableRows) {
                        line.unshift(react_1.default.createElement("td", { key: -1, style: {
                                width: 54,
                                minWidth: 54,
                                maxWidth: 54,
                                textAlign: "center",
                            } }, 
                        // tslint:disable-next-line: max-line-length
                        filteredSelectableData.find(function (selectableItem) { return item === selectableItem; }) && !(isChild || hasChildRows) ? (react_1.default.createElement(CheckBox_1.default, { className: "big", onChange: _this.handleSelectRow(item), value: selectedRows.indexOf(item) > -1 })) : (react_1.default.createElement("div", { className: "without_checkbox" }))));
                    }
                    var tableRow = (react_1.default.createElement("tr", { key: "row_" + index++, 
                        // tslint:disable:no-string-literal
                        // tslint:disable-next-line: max-line-length
                        className: classnames_1.default({ selected: selectedRows.indexOf(item) > -1 }, { error: item["valid"] === false || item["invalid"] === true }) }, line));
                    if (hasChildRows) {
                        return (react_1.default.createElement(ParentRow_1.default, { key: "row_" + index++, columns: selectedColumns, value: value, item: item, selectableRows: selectableRows, sortColumn: sortColumn }, renderRows_1(item[childrenProperty], true)));
                    }
                    else if (hasSubContent && subContent) {
                        return (react_1.default.createElement(ContentRow_1.default, { key: "row_" + index++, columns: selectedColumns, value: value, item: item, selectableRows: selectableRows, sortColumn: sortColumn }, subContent(item)));
                    }
                    else {
                        return tableRow;
                    }
                });
            };
            body = renderRows_1(data);
        }
        else {
            body = (react_1.default.createElement("tr", null,
                react_1.default.createElement("td", { colSpan: selectableRows ? selectedColumns.length + 1 : selectedColumns.length }, LocaleProvider_1.default.locs.datatable.emptyRow)));
        } // ELSE EMPTY ITEM
        var tableClassName = classnames_1.default("respectkit__data_table", {
            clickable: onClick !== undefined,
            column_width: fixedHeader,
        });
        var fixedHeaderContainer;
        var headerContainer;
        if ((data && data.length === 0) || !fixedHeader || needReset) {
            headerContainer = (react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null, header)));
        }
        else {
            fixedHeaderContainer = (react_1.default.createElement("div", { className: "sticky" },
                react_1.default.createElement("table", { className: tableClassName },
                    react_1.default.createElement("thead", null,
                        react_1.default.createElement("tr", null, header)))));
        }
        return (react_1.default.createElement("div", { style: { position: "relative" } },
            loading && react_1.default.createElement(ProgressIndicator_1.default, { local: true, overlay: "light" }),
            react_1.default.createElement("div", null, fixedHeaderContainer),
            react_1.default.createElement("table", { className: tableClassName, ref: this.tableRef },
                headerContainer,
                react_1.default.createElement("tbody", null, body))));
    };
    DataBody.defaultProps = {
        selectableRows: false,
        selectedRows: [],
    };
    return DataBody;
}(react_1.default.Component));
exports.default = DataBody;
//# sourceMappingURL=DataBody.js.map